import React from 'react';
import { Sparkles, Zap, Star, Trophy, Rocket } from 'lucide-react';

export default function LoadingAnimation() {
  return (
    <div className="fixed inset-0 bg-background/95 backdrop-blur-md z-50 flex items-center justify-center">
      <div className="text-center max-w-md px-6">
        {/* Main Animation Container */}
        <div className="relative mb-8">
          {/* Outer Ring */}
          <div className="w-32 h-32 mx-auto relative">
            <div className="absolute inset-0 rounded-full border-4 border-primary/20"></div>
            <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-primary animate-spin"></div>
            
            {/* Middle Ring */}
            <div className="absolute inset-3 rounded-full border-4 border-secondary/20"></div>
            <div className="absolute inset-3 rounded-full border-4 border-transparent border-t-secondary animate-spin" style={{ animationDirection: 'reverse', animationDuration: '1.5s' }}></div>
            
            {/* Center Icon */}
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="relative">
                <Sparkles className="w-12 h-12 text-primary animate-pulse" />
                <div className="absolute inset-0 animate-ping-slow">
                  <Sparkles className="w-12 h-12 text-primary opacity-30" />
                </div>
              </div>
            </div>
          </div>
          
          {/* Floating Icons */}
          <div className="absolute top-0 left-1/4 animate-float" style={{ animationDelay: '0s' }}>
            <Star className="w-6 h-6 text-gold animate-pulse" />
          </div>
          <div className="absolute top-0 right-1/4 animate-float" style={{ animationDelay: '0.5s' }}>
            <Trophy className="w-6 h-6 text-secondary animate-pulse" />
          </div>
          <div className="absolute bottom-0 left-1/3 animate-float" style={{ animationDelay: '1s' }}>
            <Zap className="w-6 h-6 text-accent animate-pulse" />
          </div>
          <div className="absolute bottom-0 right-1/3 animate-float" style={{ animationDelay: '1.5s' }}>
            <Rocket className="w-5 h-5 text-pink rotate-45 animate-pulse" />
          </div>
        </div>
        
        {/* Text */}
        <h3 className="text-2xl font-bold mb-3">
          <span className="gradient-text">Crafting Your Perfect Prompt</span>
        </h3>
        <p className="text-muted-foreground mb-4 animate-pulse">
          Analyzing your requirements and generating customized AI prompt...
        </p>
        
        {/* Progress Dots */}
        <div className="flex justify-center gap-2">
          <div className="w-3 h-3 rounded-full bg-primary animate-bounce" style={{ animationDelay: '0s' }}></div>
          <div className="w-3 h-3 rounded-full bg-secondary animate-bounce" style={{ animationDelay: '0.1s' }}></div>
          <div className="w-3 h-3 rounded-full bg-accent animate-bounce" style={{ animationDelay: '0.2s' }}></div>
        </div>
        
        {/* XP Notification */}
        <div className="mt-6 p-4 rounded-lg border-2 border-primary/20 bg-gradient-to-r from-primary/5 to-secondary/5 animate-pulse">
          <div className="flex items-center justify-center gap-2 text-sm font-medium">
            <Trophy className="w-5 h-5 text-gold" />
            <span>+50 XP Coming Your Way!</span>
          </div>
        </div>
      </div>
    </div>
  );
}
